/**
 * Normalise `route.query.duo_view` (string | string[] | undefined) pour les onglets
 * tableau de bord Duo (évite les valeurs concaténées si query dupliquée).
 */
export function parseDuoDashboardView(raw) {
  const v = Array.isArray(raw) ? raw[0] : raw;
  const s = String(v ?? '').trim().toLowerCase();
  if (s === 'conjoint2' || s === '2') return 'conjoint2';
  if (s === 'couple') return 'couple';
  return 'conjoint1';
}
